<script lang="ts">
import NrTooltip from '../NrTooltip/NrTooltip.vue'
import { defineComponent, PropType } from 'vue'
import truncate from 'lodash/truncate'
export default defineComponent({
  name: 'NrTruncateText',
  components: { NrTooltip },
  props: {
    text: {
      type: String as PropType<string>,
      required: true
    },
    maxCharacters: {
      type: Number,
      default: 50
    }
  },
  computed: {
    truncatedText(): string {
      return truncate(this.text, { length: this.maxCharacters })
    },
    isTruncated(): boolean {
      return this.truncatedText !== this.text
    }
  }
})
</script>

<template>
  <NrTooltip v-if="isTruncated" :label="text">
    <span class="truncate-text is-truncated">{{ truncatedText }}</span>
  </NrTooltip>
  <span v-else class="truncate-text">{{ truncatedText }}</span>
</template>

<style scoped lang="scss">
.truncate-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.is-truncated {
  cursor: help;
}
</style>
